export const LOCALE_PREFIX =
    'scenes.Gnosus.components.EntityStack.components.StackContent.components.SearchContent.components.SearchBar'
export const ENTER_KEY_CODE = 13
